import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';

export interface IDisplayOptions {
    removeOnHide: boolean;
}

export interface IDialogMessage {
    id: string;
    title: string;
    show?: boolean;
    textAccept?: string;
    textDecline?: string;
    onAccept?: () => void;
    onDecline?: () => void;
    options?: IDisplayOptions;
}

export interface IDialog {
    renderer: () => JSX.Element | null;
    show: (message: Partial<IDialogMessage>) => void;
    hide: (message: Partial<IDialogMessage>) => void;
    isShowing: (message: Partial<IDialogMessage> & Required<{ id: string }>) => boolean;
    alert: (id: string) => IDialogMessage | undefined;
    update: (message: Partial<IDialogMessage> & { id: string }) => void;
}

export const TYPES = {
    IDialog: Symbol.for('IDialog'),
};

export function injectDialog(container: IContainer = injectOrBuildContainer()): Readonly<IDialog> {
    return container.get<IDialog>(TYPES.IDialog);
}

export function bindDialog(val: IDialog, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IDialog>(TYPES.IDialog, val);
}

export function unbindDialog(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IDialog);
}
